import {useParams} from "react-router-dom";

export default function SendSms (props) {
    const { requestId } = useParams();

    return (
        <div>
            <h1>Edit Request {requestId}</h1>
            {/* rest of your component */}
        </div>
    );
}